import http from '../utils/http';

const compositeApi = {
    /**
     * 分页获取组合场景
     */
    getCompositeScenarioByPage(options = {}, config = {}) {
        return http.get('/compositeScenario/getCompositeScenarioByPage', options, {
            ...config
        })
    },

    /**
     * 新增组合场景
     */
    addCompositeScenario(options = {}, config = {}) {
        return http.post('/compositeScenario/addCompositeScenario', options, {
            ...config
        })
    },

    /**
     * 修改组合场景
     */
    updateCompositeScenario(options = {}, config = {}) {
        return http.post('/compositeScenario/updateCompositeScenario', options, {
            ...config
        })
    },
    /**
     * 启用/禁用组合场景
     */
    updateCompositeStatus(options = {}, config = {}) {
        return http.post('/compositeScenario/updateCompositeScenarioStatus', options, {
            ...config
        })
    },
    /**
     * 删除组合场景
     */
    deleteCompositeScenario(compositeId='') {
        return http.delete(`/compositeScenario/deleteCompositeScenario?compositeId=${compositeId}`)
    },
    /**
     * 获取所有场景列表
    */
    getScenarioList(options = {}, config = {}) {
        return http.get('/scenario/getScenarioList', options, {
            ...config
        })
    },
    /**
     * 获取全部音乐分组列表
    */
    getMusicGroupList(options = {}, config = {}) {
        return http.get('/musicGroup/getMusicGroupList', options, {
            ...config
        })
    },
    /**
     * 获取全部音乐列表
    */
    getMusicList(options = {}, config = {}) {
        return http.get('/music/getMusicList', options, {
            ...config
        })
    }
}

export default compositeApi;
